module.exports = __webpack_public_path__ + "img/Temperature.f1a56f5b.png";